import { ComponentProvider, MessageSimple, useComponentContext } from 'stream-chat-react';
import type { ComponentProps } from 'react';
import { MESSAGE_INPUT_MAX_ROWS } from '@features/components/Chat/constants';
import { CustomMessageStatus } from './CustomMessageStatus';

type Props = ComponentProps<typeof MessageSimple>;

export const CustomMessageSimple = ({ additionalMessageInputProps, ...props }: Props) => {
  const existing = useComponentContext();
  return (
    <ComponentProvider value={{ ...existing, MessageStatus: CustomMessageStatus }}>
      <MessageSimple
        {...props}
        additionalMessageInputProps={{ maxRows: MESSAGE_INPUT_MAX_ROWS, ...additionalMessageInputProps }}
      />
    </ComponentProvider>
  );
};
